import {
  loginByPasswordApi,
  checkPhoneNumberApi,
  sendCodeApi,
  checkCodeApi,
  resetPasswordApi,
  refreshTokenApi,
  checkPhoneRegister
} from "@common/ict/api/auth";
import {
  LoginByPasswordVo,
  LoginByPasswordDto
} from "@common/ict/model/interface/login";
import { getUserInfoApi } from "@common/ict/api/user";
import { ICT_USER_INFO } from "@common/ict/model/data";
import { BaseAbstractService } from "@common/service/base-service/global";
import {
  CheckCodeDto,
  ResetPasswordDto,
  SendCodeDto
} from "@common/ict/model/interface/auth";
import RegCheckService from "@common/ict/service/regCheck";
import { sendEmailPasswordApi } from "@common/ict/api/email";
import { SendEmailPasswordDto } from "@common/ict/model/interface/email";

class AuthService extends BaseAbstractService {
  static loginByPassword(data: LoginByPasswordVo) {
    const { userName, password, rememberLogin } = data;
    const dataDto: LoginByPasswordDto = {
      username: userName,
      password,
      rememberLogin,
      loginType: "Login"
    };
    return loginByPasswordApi(this.request, dataDto).then(resToken => {

      return AuthService.getUserInfo().then(res => {
        const userInfo = res.body;
        window.localStorage.setItem(ICT_USER_INFO, JSON.stringify(userInfo));
        return { userInfo };
      });
    });
  }

  static getUserInfo() {
    return getUserInfoApi(this.request);
  }

  // 检查手机号是否注册
  static checkPhoneNumService(phoneNum: string) {
    return RegCheckService.checkPhoneNumByReg(phoneNum).then(() => {
      return checkPhoneNumberApi(this.request, { phoneNumber: phoneNum });
    });
  }

  // 发送验证码
  static sendCodeService(phoneNum: string) {
    const data: SendCodeDto = {
      recNum: phoneNum,
      signName: "ICT学堂",
      templateCode: "615d69cd089c4e74a04daf1c6eb96557"
    };
    return sendCodeApi(this.request, data);
  }

  // 检查手机号并发送验证码
  static checkAndSendCodeService(phoneNum: string) {
    return AuthService.checkPhoneNumService(phoneNum).then(res => {
      if (res.body) {
        return AuthService.sendCodeService(phoneNum);
      }
      return Promise.reject({
        errorMsg: "手机号未注册"
      });
    });
  }

  // 验证验证码是否正确
  static checkVerifyCode(data: { phoneNumber: string; code: string }) {
    return RegCheckService.checkCodeByReg(data.code).then(() => {
      const dataDto: CheckCodeDto = {
        phoneNumber: data.phoneNumber,
        yzmCode: data.code
      };
      return checkCodeApi(this.request, dataDto);
    });
  }
  // 验证验证码是否正确-2b
  static checkVerifyCodeTob(data: { phoneNumber: string; code: string }) {
    return RegCheckService.checkCodeByRegTob(data.code).then(() => {
      const dataDto: CheckCodeDto = {
        phoneNumber: data.phoneNumber,
        yzmCode: data.code
      };
      return checkCodeApi(this.request, dataDto);
    });
  }

  static resetPassword(data: ResetPasswordDto) {
    return RegCheckService.checkPasswordByReg(data.newPassword).then(() => {
      return resetPasswordApi(this.request, data);
    });
  }

  static sendEmailPassword(params: SendEmailPasswordDto) {
    return RegCheckService.checkEmailByReg(params.email).then(() => {
      return sendEmailPasswordApi(this.request, params);
    });
  }

  // 刷新token
  static refreshToken(refreshToken) {
    return refreshTokenApi(this.request, refreshToken).then(res => {
      return res.data;
    });
  }

  static checkPhoneRegister(phone) {
    return checkPhoneRegister(this.request, phone).then(res => {
      return res.data;
    });
  }
}
export default AuthService;
